/* unplugin-vue-components disabled */import { render } from "./AccountMenu.vue?vue&type=template&id=d52ab724&scoped=true"
import script from "./AccountMenu.vue?vue&type=script&lang=js"
export * from "./AccountMenu.vue?vue&type=script&lang=js"

import "./AccountMenu.vue?vue&type=style&index=0&id=d52ab724&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d52ab724"]])

export default __exports__